function parcelsConfigService() {

  const options = {};

  this.config = (opt) => {

    angular.merge(options, opt);

  };

  this.$get = [() => {

    if (!options) {

      throw new Error('Config options must be configured');

    }

    return options;

  }];

}

export default parcelsConfigService;


// WEBPACK FOOTER //
// ./src/services/config.service.js